module.exports = __webpack_public_path__ + "img/all.de96d79c.jpg";